import { initializeApp } from 'firebase/app';
import { getMessaging, isSupported } from 'firebase/messaging';

import env from 'config/env';

/**
 * Firebase web client config, sourced from environment variables
 * (REACT_APP_FIREBASE_*, see `src/config/env.js` and `.env`). These values are
 * public by design — they ship in the browser bundle and identify the project;
 * they are NOT secrets. The matching background service worker lives at
 * `public/firebase-messaging-sw.js` and receives the SAME config via query
 * params at registration time (see `src/services/pushNotifications.js`).
 */
export const firebaseConfig = env.firebaseConfig;

export const firebaseApp = initializeApp(firebaseConfig);

// Messaging only works where the Push API + service workers exist (and not in
// SSR/unsupported browsers). Resolve to the messaging instance or null, once.
let messagingPromise;
export const getMessagingIfSupported = () => {
  if (!messagingPromise) {
    messagingPromise = isSupported()
      .then((ok) => (ok ? getMessaging(firebaseApp) : null))
      .catch(() => null);
  }
  return messagingPromise;
};

export default firebaseApp;
